import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBNGvGob1xRGf86twcBxEaGRMxvZH8sOT0",
  authDomain: "neuro-painel.firebaseapp.com",
  databaseURL: "https://neuro-painel-default-rtdb.firebaseio.com",
  projectId: "neuro-painel",
  storageBucket: "neuro-painel.firebasestorage.app",
  messagingSenderId: "790923095549",
  appId: "1:790923095549:web:6aff1a9ff9c9ff2f31bd94"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Configurar autenticação
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

// Exportar serviços
export { auth };
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;